import $ from "cash-dom";
import apiClient from "../lib/api-client";

// ------------------------------------------------------
//  Newsletter Form
// ------------------------------------------------------

$(function () {
  $('.newsletter-form').each(function () {
    const component = this;

    $('form', component).on('submit', function (e) {
      e.preventDefault();

      const email = $('input[type=email]', component).val();

      apiClient.post('/mailing-list/subscribe', {
        'email': email,
        'tag': 'blog-reader'
      }).then(function (response) {
        $(component).addClass('newsletter-form-subscribed');
      }).catch(function (error) {
        window.alert("An error has occurred. Please try again.");
      });
    });
  });
});
